import React from "react";
import { Link } from "react-router-dom";
import Header from "../components/Header";
import Footer from "../components/Footer";
import BackToTop from "../components/BackToTop";
import "../css/SeniorManagementPage.css";

const seniorManagementData = [
  {
    slug: "thimira-s-godakumbura",
    name: "THIMIRA S. GODAKUMBURA",
    title: "Managing Director/CEO",
    qualifications:
      "B.Sc. Eng. (UoM), MBA (PIM-USJ), C.Eng. FIE (SL), FRINA (UK)",
    image: "/wp-content/uploads/2024/03/Photo-03-163x222.jpg",
    descriptionShort:
      "Appointed to the Colombo Dockyard PLC (CDPLC) board on the 19th of April 2023 as the Managing Director / Chief Executive Officer. Before being appointed as the MD/CEO Mr. Godakumbura was the Chief Operating Officer (COO) for one and a half years.",
  },
  {
    slug: "k-b-p-fernando",
    name: "K.B.P. Fernando",
    title: "Consultant (Business Development)",
    qualifications: "MBA (University of Colombo), DOT Class II (Singapore)",
    image: "/wp-content/uploads/2020/07/BENNY--165x212.jpg",
    descriptionShort:
      "He is having over 34 years of exposure in this field. Out of which, 07 years had been at sea as a qualified Marine Engineer & the rest at CDPLC in the sectors of Ship Repairs, Ship Management, Invoicing & Commercial.",
  },
  {
    slug: "p-d-gihan-ravinatha",
    name: "P.D. Gihan Ravinatha",
    title: "General Manager(Finance)/CFO",
    qualifications: "FCA, CIM(UK), MBA(PIM-USJ)",
    image: "/wp-content/uploads/2021/04/Untitled-1.png",
    descriptionShort:
      "Mr. P D Gihan Ravinatha has over 21 years' experience in the fields of management, finance, accounting, audit, taxation and treasury management and he has served nearly 15 years at Colombo Dockyard PLC.",
  },
  {
    slug: "s-h-p-k-ranathunga",
    name: "S.H.P.K. Ranatunga",
    title: "General Manager (Ship Repair Business)",
    qualifications: "B.Sc. Eng. (UoM), MBA (University of Colombo)",
    image: "/wp-content/uploads/2022/03/MrRanathunga.png",
    descriptionShort:
      "Mr. Ranatunga got his first degree in the field of Mechanical Engineering from the University of Moratuwa in 1999.",
  },
  {
    slug: "prabath-abeysinghe",
    name: "PRABATH ABEYSINGHE",
    title: "General Manager (Yard Development)",
    qualifications: "MSc. Eng. (USSR), MBA (PIM- USJ)",
    image: "/wp-content/uploads/2022/03/abesinha.png",
    descriptionShort:
      "Mr. Prabath Abeysinghe joined Colombo Dockyard PLC in 1995 straight after graduating from East Ukrainian State University (USSR) as a Trainee Engineer.",
  },
  {
    slug: "r-m-vajira-rathnayaka",
    name: "R.M. Vajira Rathnayaka",
    title: "General Manager (Supply Chain Management)",
    qualifications:
      "B.Sc., (UOK, Sri Lanka). GDMM (SIM, Singapore). MBA (USQ, Australia), Dip. (Shipping Law and Practice) (ICLP & CCC. Sri Lanka). MCPM",
    image: "/wp-content/uploads/2020/07/MR-VAJIRA-RATHNAYAKE.jpg",
    descriptionShort:
      "Mr. Vajira Rathnayake obtained his Bachelor of Science degree from the University of Kelaniya, Sri Lanka, in 1995 and his Master of Business Administration (MBA) from the University of Southern Queensland, Australia, in 2011.",
  },
  {
    slug: "mangala-de-silva",
    name: "Mangala De Silva",
    title: "General Manager (Human Resource Development & Administration)",
    qualifications:
      "PhD (PIM-USJ), MBA (PIM-USJ), M.LRHRM (Colombo), Dip.M(CIM-UK), Adv Dip in Bus. Admin (ABE-UK), MCPM, MISM (SL), Attorney-at-Law.",
    image: "/wp-content/uploads/2023/02/Mangala-De-Silva-180x220.jpg",
    descriptionShort:
      "He has over 32 years of experience at CDPLC, serving in the fields of Human Resources Management, Business Administration, and Legal & Compliance.",
  },
  {
    slug: "k-n-g-w-kariyawasam",
    name: "K. N. G. W. KARIYAWASAM",
    title: "General Manager (Production)",
    qualifications: "B.Sc. Eng (Hons)",
    image: "/wp-content/uploads/2023/11/KNGW_KARIYAWASAM.jpg",
    descriptionShort:
      "Mr. Kariyawasam is promoted as General manager (Production) in 2023 while completing 22 years of experience in the fields of ship repairing, shipbuilding, ship conversions and offshore conversions.",
  },
  {
    slug: "manori-mallikarachchi",
    name: "MANORI MALLIKARACHCHI",
    title: "Legal Consultant / Company Secretary",
    qualifications: "",
    image: "/wp-content/uploads/2016/02/23-4.jpg",
    descriptionShort:
      "Joined CDPLC in 1996. Has over 24 years of experience at CDPLC in the field of Legal, Secretarial & Compliances.",
  },
];

const dgesManagementData = [
  {
    slug: "n-m-k-b-nayakarathna",
    name: "N.M.K.B. NAYAKARATHNA",
    title: "Managing Director / CEO (DGES)",
    qualifications: "B Sc Eng(Hons)",
    image: "/wp-content/uploads/2016/02/MD-02-1.jpg",
    descriptionShort:
      "Started career as Trainee Engineer at CDPL in 1986. Over 30 years experience in the field of Marine Engineering at CDPLC. 26 Years and in Kingdom Of Saudi Arabia 2 Years.",
  },
  {
    slug: "s-d-gilbert",
    name: "S.D. GILBERT",
    title: "General Manager",
    qualifications: "BSC, Engineering, C. Eng , MIE (SL) , PG Dip ( PM)",
    image: "/wp-content/uploads/2023/06/sd-gilbert.jpg",
    descriptionShort:
      "Mr S.D. Gilbert got his first degree in the field of Mechanical Engineering from the University of Moratuwa and joined to Colombo Dockyard PLC (CDPLC) as a Trainee Engineer in 1995.",
  },
];

const SeniorManagementPage = () => {
  return (
    <>
      <Header />

      <section
        className="senior-banner"
        style={{
          backgroundImage: "url('/wp-content/uploads/2016/02/new ship 2.JPG')",
        }}
      ></section>

      <div className="senior-management-wrapper">
        <div className="center-container">
          <div className="breadcrumbs">
            <Link to="/">Home</Link> &gt; <span>Senior Management Team</span>
          </div>

          <h1 className="page-title" data-aos="fade-right">
            Senior Management Team
          </h1>

          {/* Colombo Dockyard PLC Section */}
          <div className="senior-section">
            <h2 className="section-title" data-aos="fade-right">
              Colombo Dockyard PLC
            </h2>
            <div className="senior-grid">
              {seniorManagementData.map((member, index) => (
                <div
                  key={member.slug}
                  className="senior-card"
                  data-aos="fade-up"
                  data-aos-delay={index * 100}
                >
                  <div className="senior-image">
                    <img src={member.image} alt={member.name} data-aos="fade-down" />
                  </div>
                  <div className="senior-info" data-aos="fade-up">
                    <h2>{member.name}</h2>
                    <p className="senior-title">{member.title}</p>
                    {member.qualifications && (
                      <p className="senior-qualifications">
                        {member.qualifications}
                      </p>
                    )}
                    <hr className="senior-hr" />
                    <p className="senior-description">
                      {member.descriptionShort}
                    </p>
                    <Link
                      to={`/senior-management-team/${member.slug}`}
                      className="view-more"
                    >
                      View more
                    </Link>
                  </div>
                </div>
              ))}
            </div>
          </div>

          {/* Dockyard General Engineering Services Section */}
          <div className="senior-section">
            <h2 className="section-title" data-aos="fade-right">
              Dockyard General Engineering Services
            </h2>
            <div className="senior-grid">
              {dgesManagementData.map((member, index) => (
                <div
                  key={member.slug}
                  className="senior-card"
                  data-aos="fade-up"
                  data-aos-delay={index * 100}
                >
                  <div className="senior-image">
                    <img src={member.image} alt={member.name} data-aos="fade-down" />
                  </div>
                  <div className="senior-info" data-aos="fade-up">
                    <h2>{member.name}</h2>
                    <p className="senior-title">{member.title}</p>
                    {member.qualifications && (
                      <p className="senior-qualifications">
                        {member.qualifications}
                      </p>
                    )}
                    <hr className="senior-hr" />
                    <p className="senior-description">
                      {member.descriptionShort}
                    </p>
                    <Link
                      to={`/senior-management-team/${member.slug}`}
                      className="view-more"
                    >
                      View more
                    </Link>
                  </div>
                </div>
              ))}
            </div>
          </div>
        </div>
      </div>

      <Footer />
      <BackToTop />
    </>
  );
};

export default SeniorManagementPage;
